// Matriz responsavel × tipo para a aba Pendencias (variante D).

export const PENDING_ACTION_TYPES = ["upload", "reenvio", "decision", "error"];

const INTEGRATION_LABEL = "Integration";

export function filterPendingActions(items) {
  return (items || []).filter((item) => item && item.type !== "recalc");
}

function personKeyFromAction(item) {
  const name = item?.resp?.name;
  if (name && name !== "—") return name;
  if (item?.resp?.kind === "integration") return INTEGRATION_LABEL;
  return "—";
}

export function buildPendingMatrix(items) {
  const byPerson = new Map();

  filterPendingActions(items).forEach((item) => {
    const key = personKeyFromAction(item);
    if (!byPerson.has(key)) {
      byPerson.set(key, {
        personKey: key,
        personLabel: key,
        counts: { upload: 0, reenvio: 0, decision: 0, error: 0 },
        items: [],
      });
    }
    const row = byPerson.get(key);
    if (PENDING_ACTION_TYPES.includes(item.type)) {
      row.counts[item.type] += 1;
    }
    row.items.push(item);
  });

  return Array.from(byPerson.values()).sort((a, b) => {
    if (a.personKey === INTEGRATION_LABEL) return 1;
    if (b.personKey === INTEGRATION_LABEL) return -1;
    if (a.personKey === "—") return 1;
    if (b.personKey === "—") return -1;
    return a.personLabel.localeCompare(b.personLabel, "pt-BR");
  });
}

export function detailSectionId(personKey, type) {
  return `pend-detail-${type}-${encodeURIComponent(personKey)}`;
}

/** Secoes de detalhe na ordem da matriz (pessoa × tipo). */
export function buildDetailSections(matrix) {
  const sections = [];
  matrix.forEach((row) => {
    PENDING_ACTION_TYPES.forEach((type) => {
      if (row.counts[type] <= 0) return;
      const sectionItems = row.items.filter((item) => item.type === type);
      sections.push({
        id: detailSectionId(row.personKey, type),
        personKey: row.personKey,
        personLabel: row.personLabel,
        type,
        count: sectionItems.length,
        items: sectionItems,
      });
    });
  });
  return sections;
}

export function countPendingFromActionsCount(actionsCount) {
  if (!actionsCount) return 0;
  return (
    (actionsCount.uploads || 0) +
    (actionsCount.reenvios || 0) +
    (actionsCount.decisions || 0) +
    (actionsCount.errors || 0)
  );
}
